import { render, staticRenderFns } from "./ModalLinkButton.vue?vue&type=template&id=210a17f6&scoped=true&"
import script from "./ModalLinkButton.vue?vue&type=script&lang=js&"
export * from "./ModalLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./ModalLinkButton.vue?vue&type=style&index=0&id=210a17f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a17f6",
  null
  
)

export default component.exports